import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { FreeAgentsScreen } from "@/features/night/players/FreeAgentsScreen";

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/free-agents")({
  component: LeagueFreeAgentsPage,
});

function LeagueFreeAgentsPage() {
  const { leagueId } = Route.useParams();
  return <FreeAgentsScreen leagueId={leagueId as Id<"leagues">} />;
}
